import { TermsConditionComponent } from './shared/terms-condition/terms-condition.component';
import { ProfileComponent } from './profile/profile.component';
import { CreditScoreCLAComponent } from './credit-score/credit-score-CLA/credit-score-cla.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AuthenticationGuard } from 'microsoft-adal-angular6'; // Deprecated - using MsalGuard instead
import { ContactComponent } from './contact/contact.component';
import { LoginComponent } from './login/login.component';
import { OverviewComponent } from './overview/overview.component';
import { ReportsComponent } from './reports/reports.component';
import { ParkiteReportComponent } from './parkite-report/parkite-report/parkite-report.component';
import { OverviewModuleComponent } from './overview-module/overview-module.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ProfileVerificationComponent } from './profile-verification/profile-verification/profile-verification.component';
import { RestrictEntryGuard } from './config/restrict-entry.guard';
import { ParkiteGuard } from './config/parkite.guard';
import { BridgePlusGuard } from './config/bridge-plus.guard';
import { ProfileParkiteComponent } from './profile-parkite/profile-parkite.component';
import { GstChargesComponent } from './gst-charges/gst-charges.component';
import { AddNewPlantTreesComponent } from './landscaping-and-vegetation/add-new-plant-trees/add-new-plant-trees.component';
import { ListOfPlantsTreesComponent } from './landscaping-and-vegetation/list-of-plants-trees/list-of-plants-trees.component';
import { PlantDetailsComponent } from './landscaping-and-vegetation/plant-details/plant-details.component';
import { PrintQrCodeComponent } from './landscaping-and-vegetation/print-qr-code/print-qr-code.component';
import { OpenLinkGuard } from './_Core/_Guards/open-link.guard';
import { CreateWorkEntryPermitComponent } from './work-entry-permit/create-work-entry-permit/create-work-entry-permit.component';
import { ListOfTaRequestsComponent } from './work-entry-permit/list-of-ta-requests/list-of-ta-requests.component';
import { ListOfClaRequestsComponent } from './work-entry-permit/list-of-cla-requests/list-of-cla-requests.component';
import { WorkEntryPermitDetailsComponent } from './work-entry-permit/work-entry-permit-details/work-entry-permit-details.component';
import { SmeGroupsListComponent } from './work-entry-permit/sme-groups/sme-groups-list/sme-groups-list.component';
import { SmeGroupViewComponent } from './work-entry-permit/sme-groups/sme-group-view/sme-group-view.component';
import { AdalAuthComponent } from './adal-auth/adal-auth.component';
import { MsalGuard } from '@azure/msal-angular';
import { RolePermissionRouteGuard } from './_Core/_Guards/role-permission-route.guard';
import { AuthguardService } from './config/authguard.service';

const routes: Routes = [
  // {
  //   path: 'events',
  //   loadChildren: () =>
  //     import('./events/events-cla.module').then(
  //       (m) => m.EventsCLAModule
  //     ),
  //     canActivate: [MsalGuard],
  //     canActivate: [MsalGuard],
  // },

  // {
  //   path: 'events-bp',
  //   loadChildren: () =>
  //     import('./bridgePlusEvents/eventsBP.module').then(
  //       (m) => m.EventsBPModule
  //     ),
  //     canActivate: [MsalGuard],
  // },
  {
    path: 'plantDetails/:id', //8cca588a-d637-4796-8504-48a4fe9b518a
    // canActivate: [OpenLinkGuard],
    loadChildren: () =>
      import(
        `../app/_Shared/_Components/_Generic/plantdetails/plantdetails.module`
      ).then((m) => m.PlantdetailsModule),
  },
  {
    path: 'events',
    children: [
      {
        path: '',
        canActivate: [MsalGuard, RolePermissionRouteGuard],
        data: { allowedRoles: ['Bridge+', 'Parkite'] },
        loadChildren: function () {
          if (localStorage.getItem('userType') == 'Bridge+') {
            return import(`./bridgePlusEvents/eventsBP.module`).then(
              (m) => m.EventsBPModule
            );
          } else {
            return import(`./events/events-cla.module`).then(
              (m) => m.EventsCLAModule
            );
          }
        },
      },
    ],
  },
  {
    path: 'meeting',
    loadChildren: () =>
      import('./meeting-room-CLA/meeting-room.module').then(
        (m) => m.MeetingRoomModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'members',
    loadChildren: () =>
      import('./members-CLA/members-cla.module').then(
        (m) => m.MembersCLAModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'companies',
    loadChildren: () =>
      import('./companies/companies-cla.module').then(
        (m) => m.CompaniesCLAModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./company-module/company.model').then((m) => m.CompanyModule),
    canActivate: [MsalGuard, RestrictEntryGuard],
  },
  {
    path: 'faq',
    loadChildren: () => import('./FAQs/faq.model').then((m) => m.FaqModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'bulk-invite-approval',
    loadChildren: () =>
      import('./bulk-invite-approval/approval.module').then(
        (m) => m.ApprovalModule
      ),
    // canActivate: [MsalGuard, RestrictEntryGuard]
    canActivate: [MsalGuard]
  },
  {
    path: 'landscaping-and-vegetation',
    loadChildren: () =>
      import('./landscaping-and-vegetation/landscaping.module').then(
        (m) => m.LandscapingModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'customer-service-group',
    loadChildren: () =>
      import('./customer-service-group/customerservice.module').then(
        (m) => m.CustomerserviceModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'coupons',
    loadChildren: () =>
      import('./coupons/couponsection.module').then(
        (m) => m.CouponsectionModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'survey-polls',
    loadChildren: () =>
      import('./survey-polls/surveypolls.module').then(
        (m) => m.SurveypollsModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'food-court',
    loadChildren: () =>
      import('./food-court/foodcourt.module').then(
        (m) => m.FoodcourtModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'assign-membercard',
    loadChildren: () =>
      import('./assign-membercard/assignmembercard.module').then(
        (m) => m.AssignmembercardModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'work-entry-permit',
    loadChildren: () =>
      import('./work-entry-permit/workpermit.module').then(
        (m) => m.WorkpermitModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'bridgeplus-vms',
    loadChildren: () =>
      import('./bridgeplusVMS/vms.module').then((m) => m.VmsModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'park-info',
    loadChildren: () =>
      import('./park-info/park-info.module').then((m) => m.ParkInfoModule),
    canActivate: [MsalGuard],
  },
  {
    path: 'overview',
    component: OverviewComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'update-gst',
    component: GstChargesComponent,
    canActivate: [MsalGuard],
  },

  {
    path: 'profile-parkite',
    component: ProfileParkiteComponent,
    canActivate: [MsalGuard],
  },

  // {
  //   path: 'login',
  //   // component: LoginComponent,
  // },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'credits',
    component: CreditScoreCLAComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '',
    component: LoginComponent,
    canActivate: [MsalGuard], //MsalGuard
  },
  {
    path: 'feedback',
    loadChildren: () =>
      import('./feedback/feedback.module').then((m) => m.FeedbackModule),
  },
  {
    path: 'parkite-reports',
    component: ParkiteReportComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'parkite-overview',
    component: OverviewModuleComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'bulletins',
    loadChildren: () =>
      import('./bulletins/bulletin.module').then((m) => m.BulletinModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'deals',
    loadChildren: () =>
      import('./Deals/deals.module').then((m) => m.DealsModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'facility',
    loadChildren: () =>
      import('./facility-booking/facility/facility.module').then(
        (m) => m.FacilityModule
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'whitelist',
    loadChildren: () =>
      import('./whiteList/accessApproval.module').then(
        (m) => m.AccessApprovalModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'capitastar-work-india-terms-and-condition',
    component: TermsConditionComponent,
  },

  {
    path: 'terms-condition',
    component: TermsConditionComponent,
  },

  {
    path: 'resetPassword',
    component: ResetPasswordComponent,
  },
  {
    path: 'vmsGuest',
    loadChildren: () =>
      import(`./qrcode/qrcode.module`).then((m) => m.QrcodeModule),
  },
  {
    path: 'verifyemail',
    component: ProfileVerificationComponent,
  },
  {
    path: 'add-new-plant-trees',
    component: AddNewPlantTreesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'plant-details/:id',
    component: PlantDetailsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'list-of-plants-trees',
    component: ListOfPlantsTreesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'print-qr-code',
    component: PrintQrCodeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'create-work-entry-permit',
    component: CreateWorkEntryPermitComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'list-ta-admin-requests',
    component: ListOfTaRequestsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'list-cla-admin-requests',
    component: ListOfClaRequestsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'work-entry-permit-details/:id',
    component: WorkEntryPermitDetailsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'sme-groups',
    component: SmeGroupsListComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'sme-group-details/:id',
    component: SmeGroupViewComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'auth',
    component: AdalAuthComponent,
  },
  {
    path: 'emergency-info',
    loadChildren: () =>
      import('./emergency-info/emergencyinfo.module').then(
        (m) => m.EmergencyinfoModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'role-permission',
    loadChildren: () =>
      import('./role-permission/rolepermission.module').then(
        (m) => m.RolepermissionModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  {
    path: 'meeting-room',
    loadChildren: () =>
      import('./meeting-room/meetingroom.module').then(
        (m) => m.MeetingroomModule
      ),
    canActivate: [MsalGuard, RestrictEntryGuard]
  },
  // {path: 'meeting/meetingroom-details', component: MeetingRoomDetailsComponent},
  // {path: 'meeting/meetingroom-list', component: MeetingRoomListComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { } //componant
